import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
// import classNames from "classnames";
// import styles from "../styles/games-suggestions-widget.module.scss";

const GamesSuggestionsWidgetAsyncComponent = AsyncComponent(async () => import('./games-suggestions-widget' /* webpackChunkName: "games-suggestions-widget" */ ));

export const GamesSuggestionsWidgetAsync = (props) => {
  return <React.Suspense>
    <GamesSuggestionsWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
